import { Modal } from "flowbite-react";
import { FlatButton } from "../buttons";
import { useEffect, useRef, useState } from "react";

export function Attachments({ attachmentHandler, popup }) {
  const [openModal, setopenModal] = useState();
  const [errors, setErrors] = useState([]);
  const { attachments, addFiles } = attachmentHandler;
  const fileInputRef = useRef();

  useEffect(() => {
    attachmentHandler.addErrorHandler((error) => {
      setErrors([...errors, error?.message]);
    });
  }, []);

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        accept={attachmentHandler.meta.accept}
        className="sr-only"
        onChange={(e) => {
          if (e.target.files.length > 0) {
            addFiles(e.target.files);
          }
        }}
      />
      {popup ? (
        <>
          <span class="relative inline-block">
            <FlatButton
              appearance="custom"
              onClick={() => {
                setopenModal("pop-up");
              }}
              className="hover:bg-gray-200/50 flex items-center text-sm text-gray-800 "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"
                />
              </svg>
              Attachments
            </FlatButton>
            {attachments.length > 0 && (
              <span className="absolute text-xs p-[2px] text-center text-white right-0 top-1 block w-5 h-5 -translate-y-1/2 translate-x-1/2 transform rounded-full bg-indigo-600 ring-2 ring-white">
                {attachments.length}
              </span>
            )}
          </span>
          <Modal
            show={openModal}
            size="4xl"
            popup
            onClose={() => {
              setopenModal();
            }}
          >
            <Modal.Header
              theme={{
                title:
                  "w-full text-xl font-medium text-gray-900 dark:text-white p-2",
                close: {
                  base: "hidden sr-only",
                },
              }}
            >
              <div className="flex w-full">
                <p>Add Attachments</p>
                <FlatButton onClick={() => setopenModal()} className="ml-auto">
                  Continue
                </FlatButton>
              </div>
            </Modal.Header>
            <Modal.Body>
              <div
                onClick={() => {
                  fileInputRef.current?.click();
                }}
                class="bg-gray-50 w-full text-center px-4 rounded w-80 flex flex-col items-center justify-center cursor-pointer border-2 border-gray-400 border-dashed mx-auto font-[sans-serif]"
              >
                <div class="pt-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-10 mb-2 fill-gray-600 inline-block"
                    viewBox="0 0 32 32"
                  >
                    <path
                      d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                      data-original="#000000"
                    />
                    <path
                      d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                      data-original="#000000"
                    />
                  </svg>
                  {/* <h4 class="text-base font-semibold text-gray-600">
                drag and drop files here
              </h4> */}
                </div>
                {/* <hr class="w-full border-gray-400 my-2" /> */}
                <div class="pb-6">
                  <label
                    for="uploadFile1"
                    class="block px-6 py-2.5 rounded text-gray-600 text-sm tracking-wider font-semibold border-none outline-none"
                  >
                    Click to upload or drag and drop.
                  </label>
                  <p class="text-xs text-gray-400 mt-4">
                    Audio, PDF, DOC, XLS, Compress
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="overflow-x-auto">
              <div className="text-sm text-gray-800 flex gap-x-2">
                {attachments.map((_atmt) => {
                  const _split = _atmt.attachment_name.split(".");
                  const _ext =
                    _split.length > 1 ? _split[_split.length - 1] : "File";
                  // <Tooltip content={_atmt.attachment_name} placement="bottom">
                  return (
                    <div className="flex h-16 min-w-[225px] max-w-[225px] bg-gray-100 border-1 p-2 gap-x-2 rounded-md shadow-md items-center">
                      <div className="h-14 w-14 min-w-[3.5rem] rounded-md bg-gray-400 flex justify-center items-center">
                        <p className="text-md text-center text-white uppercase font-bold">
                          {_ext}
                        </p>
                        {/* )} */}
                      </div>
                      <div className="inline-block min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                        <p className="min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                          {_atmt.attachment_name}
                        </p>
                        <p>{(_atmt.attachment_size / 1024).toFixed(2)} KB</p>
                      </div>
                      <div
                        onClick={(e) => {
                          attachmentHandler.remove(_atmt);
                        }}
                        className="hover:bg-gray-300 rounded-full ml-auto"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="100%"
                          height="100%"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-x cursor-pointer hover:text-gray-800 rounded-full w-4 h-4"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </div>
                    </div>
                  );
                  // </Tooltip>
                })}
              </div>
            </Modal.Footer>
          </Modal>
        </>
      ) : (
        <div className="grid grid-cols-3 h-[260px] w-full p-2">
          <p className="col-span-3 mb-3">Attachments ({attachments.length})</p>
          <div
            onClick={() => {
              fileInputRef.current?.click();
            }}
            class="bg-gray-50 h-full text-center px-4 rounded flex flex-col items-center justify-center cursor-pointer border-2 border-gray-400 border-dashed mx-auto font-[sans-serif]"
          >
            <div class="pt-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-10 mb-2 fill-gray-600 inline-block"
                viewBox="0 0 32 32"
              >
                <path
                  d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z"
                  data-original="#000000"
                />
                <path
                  d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z"
                  data-original="#000000"
                />
              </svg>
              {/* <h4 class="text-base font-semibold text-gray-600">
                drag and drop files here
              </h4> */}
            </div>
            {/* <hr class="w-full border-gray-400 my-2" /> */}
            <div class="pb-6">
              <label
                for="uploadFile1"
                class="block px-6 py-2.5 rounded text-gray-600 text-sm tracking-wider font-semibold border-none outline-none"
              >
                Click to upload or drag and drop.
              </label>
              <p class="text-xs text-gray-400 mt-4">
                Audio, PDF, DOC, XLS, Compress
              </p>
            </div>
          </div>
          <div className="text-sm col-span-2 text-gray-800 grid grid-cols-3 gap-3 overflow-auto p-2 mt-2">
            {attachments.map((_atmt) => {
              const _split = _atmt.attachment_name.split(".");
              const _ext =
                _split.length > 1 ? _split[_split.length - 1] : "File";
              // <Tooltip content={_atmt.attachment_name} placement="bottom">
              return (
                <div className="flex h-16 bg-gray-100 border-1 p-2 gap-x-2 rounded-md shadow-md items-center">
                  <div className="h-14 w-14 min-w-[3.5rem] rounded-md bg-gray-400 flex justify-center items-center">
                    <p className="text-md text-center text-white uppercase font-bold">
                      {_ext}
                    </p>
                    {/* )} */}
                  </div>
                  <div className="inline-block min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                    <p className="min-w-0 whitespace-nowrap text-ellipsis overflow-hidden">
                      {_atmt.attachment_name}
                    </p>
                    <p>{(_atmt.attachment_size / 1024).toFixed(2)} KB</p>
                  </div>
                  <div
                    onClick={(e) => {
                      attachmentHandler.remove(_atmt);
                    }}
                    className="hover:bg-gray-300 rounded-full ml-auto"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="100%"
                      height="100%"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-x cursor-pointer hover:text-gray-800 rounded-full w-4 h-4"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </div>
                </div>
              );
              // </Tooltip>
            })}
          </div>
        </div>
      )}
    </>
  );
}

export function useAttachmentHandler({
  accept,
  maxSize = "20",
  maxCount,
  autoUpload,
  uploadHandler,
  errorHandler,
}) {
  const [attachments, setAttachments] = useState([]);

  const addErrorHandler = (handler) => {
    errorHandler = errorHandler || handler;
  };

  const adduploadHandler = (handler) => {
    uploadHandler = uploadHandler || handler;
  };

  const addFiles = (files) => {
    try {
      const append = [];
      for (let file of files) {
        if (file.attachment_url || file.attachment_key) {
          file._id = file.attachment_name + "-" + Date.now().toString(36);
          append.push(file);
          continue;
        }
        let _file = {
          _id: file.name + "-" + Date.now().toString(36),
          attachment_name: file.name,
          attachment_type: file.type,
          attachment_size: file.size,
        };

        if (maxCount && attachments.length + append.length === maxCount) {
          errorHandler &&
            errorHandler({ message: `Can't add more than ${maxCount} files.` });
          break;
        }

        if (accept && !accept.split(" ").includes(file.name.split(".")[1])) {
          errorHandler &&
            errorHandler({
              message: `Can't add ${file.name}. File type not supported.`,
            });
          continue;
        }

        if (maxSize && file.size > maxSize * 1024 * 1024) {
          errorHandler &&
            errorHandler({
              message: `Can't add ${file.name}. File size exceded.`,
            });
          continue;
        }

        if (autoUpload && uploadHandler) {
          uploadHandler(file).then((url) => {
            _file.attachment_url = url;
          });
        } else {
          _file.blobInfo = file;
        }

        append.push(_file);
      }
      setAttachments([...attachments, ...append]);
    } catch (err) {
      errorHandler && errorHandler(err);
    }
  };

  const remove = (file) => {
    setAttachments(attachments.filter((_file) => _file._id !== file._id));
  };

  const reset = () => {
    setAttachments([]);
  };
  return {
    attachments,
    addFiles,
    meta: {
      accept,
      maxCount,
      maxSize,
    },
    addErrorHandler,
    adduploadHandler,
    remove,
    reset,
  };
}
